import React, { Fragment } from 'react';
import { useState } from 'react';
import moment from 'moment';
import {
    Row, Col,
    Modal, ModalHeader, Input, ModalBody, ModalFooter, Form, Button, Card, CardBody
} from "reactstrap";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Dropzone from 'react-dropzone-uploader';
import RequestForChnageModal from './modal-in-modal/request-for-change-modal';
import { savePolicyHistory } from '../../../../../api/dealership';
import { toast } from "react-toastify";
import { useEffect } from 'react';
import { getDocumentById, geographicalCountry, getActiveFuel, getAllFuel, getAllModel, getActiveTransmission, getAllVariant, getModelsByBrandById, getPolicyDetailsById, getVariantById, getVariantByModelId, stateCityByPincode, getActiveTransmissione, forceDocumentEdit, stateCityByActiveMasterPincode, getClientConfig } from '../../../../../api';
import { useForm } from "react-hook-form";
import Select from "react-select";
import axios from 'axios';
import GetModalFooter from '../../../../common/getModalFooter';
import RequiredIndicator from '../../../../partial/RequiredIndicator';
import GetLoader from "../../../../common/getLoader";
import { getFromLocalStorage } from '../../../../../hooks/useLocalStorage';
import SweetAlert from 'sweetalert2';
import checkClientConfig from '../../../../../utilities/checkClientConfig';
import FileUploadComponent from '../../../../common/FileUpload';
import { formattedDateOnly } from '../../../../../utilities/formatedDate';
import { create } from 'lodash';
import getTitle from '../../../../../utilities/getTitle';
import Swal from 'sweetalert2';
import { COMPANY_MASTER_PINCODE } from '../../../../../constant';

const EditPolicyProductChangeModal = ({ selectedPolicyData, toggle, brand, isOpen, data, existing, setData, setModifiedData, mappingFuel, mappingTransmission, refresh, setEditPolicyProductChangeModal, adminColumn }) => {

    //sucess message 
    const documentOldData = selectedPolicyData
    console.log(documentOldData, "documentOldData");
    const schema = yup.object().shape({
        proposers: yup.array().of(
            yup.object().shape({
                gender: yup.string().required("Gender is required"),
                proposer_passport_number: yup.string().notRequired(),
                // .required("Passport is required")
                //     .matches(/^[a-zA-Z0-9]{8,9}$/, "Invalid Indian passport number"),
                proposer_dob: yup.string(),
                proposer_title: yup.string().required("Title is required"),
                proposer_first_name: yup.string().required("First Name is required"),
                proposer_last_name: yup.string().required("Last Name is required"),
                proposer_address: yup.string().required("Address is required"),
                proposer_email: yup.string().required("Email is required")
                    .matches(
                        /^[a-zA-Z0-9._-]+@([a-zA-Z0-9.-]+\.)+[a-zA-Z]{2,4}$/,
                        "Email is invalid"
                    ),
                proposer_mobile: yup.string().required("Mobile is required")
                    .matches(/^\d{10}$/, "Only numbers allowed")
                    .length(10, "Mobile Number should be 10 digits"),
                proposer_pin_code: yup
                    .string()
                    .required("Pincode is required")
                    .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits"),
                city: yup
                    .string()
                    .required("City is required")
                    .test(
                        "not-default-city",
                        "City is required",
                        (value) => value && value !== "Select City"
                    )
            })

        ),
        travellers: yup.array().of(
            yup.object().shape({
                traveller_passport: yup.string().notRequired(),
                // .required("Passport is required")
                //     .matches(/^[a-zA-Z0-9]{8,9}$/, "Invalid  passport number"),
                traveller_dob: yup.string(),
                title: yup.string().required("Title is required"),
                firstName: yup.string().required("First Name is required"),
                // middleName: yup.string().required("Middle Name is required"),
                lastName: yup.string().required("Last Name is required"),
                gender: yup.string().required("Gender is required"),
            })
        ),
        nominees: yup.array().of(
            yup.object().shape({
                nominee_relation: yup.string().required("Relationship is required"),
            })
        ),
        created_reason: yup.string().required("Reason is required"),
        created_remark: yup.string().required("Remark is required"),
    });

    const { handleSubmit, register, setValue, trigger, getValues, formState: { errors }, reset, setError, unregister, clearErrors, control, watch } = useForm({
        resolver: yupResolver(schema),
    });

    const [countryList, setCountryList] = useState([]);
    const [selectedGeographicalCoverId, setGeographicalCoverId] = useState("");
    const [requestForChnageModal, setRequestForChnageModal] = useState(false);
    const [policyData, setPolicyData] = useState({});
    const [fuel, setFuel] = useState([]);
    const [reasonDocument, setReasonDocument] = useState("");
    const [transmission, setTransmission] = useState([]);
    const [model, setModel] = useState([]);
    const [variant, setVariant] = useState([]);
    const [country, setCountry] = useState([])
    const [countryError, setCountryError] = useState(false);
    const [stateDetails, setStateDetails] = useState({});
    const [cityDetails, setCityDetails] = useState({});
    const [isAMT, setIsAMT] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dealerInfo] = useState(getFromLocalStorage("user")?.dealerInfo);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [oldStartDate, setOldStartDate] = useState("");
    const [newStartDate, setNewStartDate] = useState("");
    const [oldEndDate, setOldEndDate] = useState("");
    const [newEndDate, setNewEndDate] = useState("");
    const [ticketID, setTicketID] = useState('');
    const [cityOptions, setCityOptions] = useState(null);

    const toggleRequestForChangeModal = () => setRequestForChnageModal(!requestForChnageModal);

    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id;
    const role_name = ROLE?.name;

    const options = [
        { label: "Select Reason", value: "" },
        { label: "Change of plan", value: "Change of plan" },
        { label: "Incorrect details-Journey", value: "Incorrect details-Journey" },
        { label: "Incorrect details-Traveller", value: "Incorrect details-Traveller" },
        { label: "Medical reasons", value: "Medical reasons" },
        { label: "Others", value: "Others" }
    ];

    const [selectedOption, setSelectedOption] = useState(null);
    useEffect(async () => {
        await fetchCountryList(selectedPolicyData?.geographical_cover?.id);
        await setPolicyData(selectedPolicyData)
    }, []);
    console.log('policyData', policyData);
    useEffect(() => {
        if (isAMT) {
            setCountryError(false);
        }
    }, [isAMT]);

    useEffect(async () => {
        const country = policyData?.country_map_docs?.map(item => ({
            value: item.Country?.country_id, // Assuming country_id is the value
            label: item.Country?.name // Assuming country_name is the display name
        })) || []; // Fallback to an empty array if no countries are found
        await setCountry(country);
        let pincode = policyData?.proposers?.length > 0 ? policyData?.proposers?.[0]?.proposer_pin_code : null;
        if (pincode) await handlePincodeChange(pincode)
        reset({
            travellers: policyData.travellers,
            proposers: policyData.proposers,
            nominees: policyData.nominees,
        });

        
        const travellerCriticalIllnessValue = normalizeCriticalIllness(policyData?.travellers?.[0]?.critical_illness);
        if (travellerCriticalIllnessValue) {
            setValue('travellers[0].critical_illness', travellerCriticalIllnessValue);
        }

        if (policyData?.nominees?.[0]) {
            const nom = policyData.nominees[0];
            setValue('nominees[0].nominee_relation', normalizeNomineeRelation(nom.nominee_relation || ""));
            setValue('nominees[0].nominee_title', nom.nominee_title || nom.title || "");
            setValue('nominees[0].nominee_gender', nom.nominee_gender || nom.gender || "");
        }

        try {
            const sd = policyData?.travel_start_date ? moment(policyData.travel_start_date).format('YYYY-MM-DD') : '';
            const ed = policyData?.travel_end_date ? moment(policyData.travel_end_date).format('YYYY-MM-DD') : '';
            // detect AMT locally for prefill behavior
            const planTitleForDetect = (policyData?.type?.title || '').toString();
            const amtDetected = /\bAMT\b/i.test(planTitleForDetect) || /annual\s*multi\s*trip/i.test(planTitleForDetect);
            setIsAMT(amtDetected)
            if (!amtDetected && country.length === 0) {
                setCountryError(true);
                return; // prevent API call
            } else {
                setCountryError(false);
                // proceed with API call
            }

            if (amtDetected && sd) {
                const autoEnd = calcAmtEndDate(sd);
                setStartDate(sd);
                setEndDate(autoEnd);
                setValue('startDate', sd);
                setValue('endDate', autoEnd);
                setNoOfDays('365');
                setValue('noOfdays', '365');
                await trigger('startDate');
                await trigger('endDate');
                await trigger('noOfdays');
            } else {
                setStartDate(sd);
                setEndDate(ed);
                setValue('startDate', sd);
                setValue('endDate', ed);
                // derive noOfdays either from policyData or by calculation
                const tnodPrefill = policyData?.number_of_travel_days ? String(policyData.number_of_travel_days) : calculateTravelDays(sd, ed);
                setNoOfDays(tnodPrefill || '');
                setValue('noOfdays', tnodPrefill || '');
                await trigger('startDate');
                await trigger('endDate');
                await trigger('noOfdays');
            }
        } catch (err) {
        }
    }, [policyData]);

    const normalizeTitle = (val) => {
        if (!val) return "";
        const clean = String(val).replace(/\./g, '').trim().toLowerCase();
        if (clean === 'mr') return 'Mr';
        if (clean === 'mrs') return 'Mrs';
        if (clean === 'ms') return 'Ms';
        if (clean === 'miss') return 'Miss';
        if (clean === 'dr') return 'Dr';
        if (clean === 'prof') return 'Prof';
        if (clean === 'master') return 'Master';
        return val;
    };

    const normalizeGender = (val) => {
        if (!val) return "";

        const clean = String(val)
            .replace(/<strong class="___1qwroh2 fl43uef f19n0e5" data-lexical-text="true">\.<\/strong>/g, '')
            .trim()
            .toLowerCase();

        if (clean === 'male' || clean === 'm') return 'MALE';
        if (clean === 'female' || clean === 'f') return 'FEMALE';
        if (clean === 'others' || clean === 'other' || clean === 'o') return 'OTHERS';

        return val;
    };

    const pinCode = register("proposers[0].proposer_pin_code");

    useEffect(() => {
        console.log("PinCode:", pinCode);
    }, [pinCode]);

    const normalizeCriticalIllness = (val) => {
        if (!val) return "";
        const clean = String(val).trim().toLowerCase();
        if (clean === 'no critical illness' || clean === 'none') return 'None';
        return String(val);
    };

    const normalizeNomineeRelation = (val) => {
        if (!val) return "";
        const clean = String(val).trim().replace(/_/g, ' ').replace(/\s+/g, ' ').toLowerCase();
        const mapping = {
            'spouse': 'spouse ',
            'son': 'Son',
            'daughter': 'Daughter',
            'mother': 'Mother',
            'father': 'Father',
            'brother': 'Brother',
            'sister': 'Sister',
            'grand father': 'Grand_Father',
            'grand mother': 'Grand_Mother',
            'grandson': 'Grandson',
            'grand daughter': 'Grand_Daughter',
            'guardian': 'Guardian',
            'legal heir': 'Legal_Heir',
            'legal heir ': 'Legal_Heir',
        };
        return mapping[clean] || String(val).trim();
    };

    const proposerTitle = normalizeTitle(watch('proposers[0].proposer_title') || policyData?.proposer_title?.[0]?.proposer_title || policyData?.proposer_title?.[0]?.title ||"");
    const nomineeTitle = normalizeTitle(watch('nominees[0].nominee_title') || policyData?.nominees?.[0]?.nominee_title || policyData?.nominees?.[0]?.title || "");
    const nomineeGender = normalizeGender(watch('nominees[0].nominee_gender') || policyData?.nominees?.[0]?.nominee_gender || policyData?.nominees?.[0]?.gender || "");
    const nomineeRelationValue = normalizeNomineeRelation(watch('nominees[0].nominee_relation') || policyData?.nominees?.[0]?.nominee_relation || "");
    const travellerCriticalIllnessValue = watch('travellers[0].critical_illness') || normalizeCriticalIllness(policyData?.travellers?.[0]?.critical_illness) || "";

    const fetchCountryList = async (geopgraphicalId) => {
        if (geopgraphicalId) {
            try {
                const response = await geographicalCountry(geopgraphicalId);
                const data = response?.data?.result;

                // Assuming the API returns an array of countries
                const countryOptions = data.map((country) => ({
                    value: country?.Country?.country_id,
                    label: country?.Country?.name,
                }));

                setCountryList(countryOptions);

            } catch (error) {
                console.error("Error fetching country list:", error);
            }
        }


    };

    const submitDetails = async (data) => {

        let changesValues = [];
        if (country.length == 0 && !isAMT) {
            setCountryError(true);
            return;
        }

        setIsSubmitting(true);
        let countryUpdated = Array.isArray(country) ? country.map(i => ({
            country_id: i.value,
            document_id: policyData?.document_id
        })) : [];

        let documentData = {
            ...policyData,
            travellers: [
                {
                    ...policyData.travellers[0], // Copy the first traveller's existing data
                    traveller_dob: data?.travellers[0]?.traveller_dob || policyData?.travellers[0]?.traveller_dob,
                    firstName: data?.travellers[0]?.firstName || policyData.travellers[0].firstName || "", // Update if exists, or keep existing
                    lastName: data?.travellers[0]?.lastName || policyData.travellers[0].lastName || "",
                    middleName: data?.travellers[0]?.middleName || policyData.travellers[0].middleName || "",
                    traveller_passport: data?.travellers.length > 0 && data?.travellers[0]?.traveller_passport || policyData.travellers[0]?.traveller_passport || "",
                    title: data?.travellers[0]?.title || policyData.travellers[0]?.title || null,
                    gender: data?.travellers[0]?.gender || policyData.travellers[0]?.gender || null,
                    addons: data?.travellers[0]?.addons || policyData.travellers[0]?.addons || null,
                },
                ...policyData.travellers.slice(1) // Keep the rest of the travellers unchanged
            ],
            proposers: [{
                ...policyData.proposers[0],
                proposer_dob: data?.proposers[0]?.proposer_dob || policyData.proposers[0].proposer_dob,
                gender: data?.proposers[0]?.gender || policyData.proposers[0].gender,
                proposer_passport_number: data?.proposers[0]?.proposer_passport_number || policyData.proposers[0].proposer_passport_number,
                proposer_title: data?.proposers[0]?.proposer_title || policyData.proposers[0].proposer_title,
                proposer_first_name: data?.proposers[0]?.proposer_first_name || policyData.proposers[0].proposer_first_name,
                proposer_middle_name: data?.proposers[0]?.proposer_middle_name || policyData.proposers[0].proposer_middle_name,
                proposer_last_name: data?.proposers[0]?.proposer_last_name || policyData.proposers[0].proposer_last_name,
                proposer_pin_code: data?.proposers[0]?.proposer_pin_code || policyData.proposers[0].proposer_pin_code,
                state: data?.proposers[0]?.state || policyData?.proposers[0]?.state,
                city: data?.proposers[0]?.city || policyData?.proposers[0]?.city,
                proposer_address: data?.proposers[0]?.proposer_address || policyData.proposers[0].proposer_address,
                proposer_email: data?.proposers[0]?.proposer_email || policyData.proposers[0].proposer_email,
                proposer_mobile: data?.proposers[0]?.proposer_mobile || policyData.proposers[0].proposer_mobile,
            },
            ...policyData.proposers.slice(1)
            ],
            nominees: [{
                ...policyData.nominees[0],
                nominee_relation: data?.nominees[0]?.nominee_relation || policyData.nominees[0].nominee_relation,
                nominee_firstName: data?.nominees[0]?.nominee_firstName || policyData.nominees[0].nominee_firstName,
                nominee_middleName: data?.nominees[0]?.nominee_middleName || policyData.nominees[0].nominee_middleName,
                nominee_lastName: data?.nominees[0]?.nominee_lastName || policyData.nominees[0].nominee_lastName,
                nominee_title: data?.nominees[0]?.nominee_title || data?.nominees[0]?.title || policyData.nominees[0].nominee_title || policyData.nominees[0].title,
                title: data?.nominees[0]?.nominee_title || data?.nominees[0]?.title || policyData.nominees[0].title || policyData.nominees[0].nominee_title,
                nominee_dob: data?.nominees[0]?.nominee_dob || policyData.nominees[0].nominee_dob,
                nominee_gender: data?.nominees[0]?.nominee_gender || data?.nominees[0]?.gender || policyData.nominees[0].nominee_gender || policyData.nominees[0].gender,
                gender: data?.nominees[0]?.nominee_gender || data?.nominees[0]?.gender || policyData.nominees[0].gender || policyData.nominees[0].nominee_gender,
            }, ...policyData.nominees.slice(1)],
            created_reason: data?.created_reason || "",
            created_remark: data?.created_remark || "",
            image_url: data?.image_url || "",
            updated_by_role_id: role_id,
            updated_by_role: role_name

        };

        if (countryUpdated.length > 0 && countryUpdated.length != policyData?.country_map_docs?.length) {
            documentData['CountryUpdated'] = countryUpdated;
            documentData['selectedCountries'] = country;
        }

        let proposerDetailsOld = documentOldData?.proposers?.[0]
        let travellerDetailsOld = documentOldData?.travellers?.[0]
        let nomineesDetailsOld = documentOldData?.nominees?.[0]

        let proposerDetailsUpdate = documentData?.proposers[0]
        let travellerDetailsUpdate = documentData?.travellers[0]
        let nomineeDetailsUpdate = documentData?.nominees[0]

        if (proposerDetailsOld && proposerDetailsUpdate) {
            const changedFields = Object.keys(proposerDetailsOld).reduce((acc, key) => {
                if (
                    proposerDetailsUpdate.hasOwnProperty(key) &&
                    String(proposerDetailsOld[key]) !== String(proposerDetailsUpdate[key])
                ) {
                    acc.push({
                        title: getTitle(key),
                        old: proposerDetailsOld[key],
                        new: proposerDetailsUpdate[key]
                    });
                }
                return acc;
            }, []);

            changesValues = changesValues.concat(changedFields);
        }

        if (travellerDetailsOld && travellerDetailsUpdate) {
            const changedFields = Object.keys(travellerDetailsOld).reduce((acc, key) => {
                if (
                    travellerDetailsUpdate.hasOwnProperty(key) &&
                    travellerDetailsOld[key] !== travellerDetailsUpdate[key]
                ) {
                    acc.push({
                        title: getTitle(key),
                        old: travellerDetailsOld[key],
                        new: travellerDetailsUpdate[key]
                    });
                }
                return acc;
            }, []);
            changesValues = changesValues.concat(changedFields); // <-- fix here
            // setProposerChangedFields(changedFields);
        }

        if (nomineesDetailsOld && nomineeDetailsUpdate) {
            const allNomineeKeys = Array.from(new Set([...Object.keys(nomineesDetailsOld), ...Object.keys(nomineeDetailsUpdate)]));
            const changedFields = allNomineeKeys.reduce((acc, key) => {
                if (key === 'gender') return acc;
                if (
                    nomineeDetailsUpdate.hasOwnProperty(key) &&
                    String(nomineesDetailsOld[key] || '') !== String(nomineeDetailsUpdate[key] || '') &&
                    key !== 'nominee_id' && key !== 'id'
                ) {
                    acc.push({
                        title: getTitle(key),
                        old: nomineesDetailsOld[key] || null,
                        new: nomineeDetailsUpdate[key] || null
                    });
                }
                return acc;
            }, []);
            changesValues = changesValues.concat(changedFields); // <-- fix here
            // setProposerChangedFields(changedFields);
        }

        const countryOld = documentOldData?.country_map_docs;
        const countryupdated = documentData?.selectedCountries;
        if (countryOld && countryupdated) {
            const oldCountryNames = countryOld
                .map(item => item?.Country?.name)
                .filter(Boolean)
                .join(', ');

            // New: countryUpdated is an array of objects, each has label: "..."
            const newCountryNames = countryupdated
                .map(item => item?.label)
                .filter(Boolean)
                .join(', ');

            // Add to changesValues array
            changesValues.push({
                title: 'Country',
                old: oldCountryNames,
                new: newCountryNames
            });
        }

        // compare formatted values and only include changed fields
        const oldStart = documentOldData?.travel_start_date ? moment(documentOldData.travel_start_date).format('YYYY-MM-DD') : '';
        const oldEnd = documentOldData?.travel_end_date ? moment(documentOldData.travel_end_date).format('YYYY-MM-DD') : '';
        const oldDays = documentOldData?.number_of_travel_days != null ? String(documentOldData.number_of_travel_days) : '';

        const newStart = data?.startDate
            ? moment(data.startDate).format('YYYY-MM-DD')
            : policyData?.travel_start_date
                ? moment(policyData.travel_start_date).format('YYYY-MM-DD')
                : '';
        const newEnd = data?.endDate
            ? moment(data.endDate).format('YYYY-MM-DD')
            : policyData?.travel_end_date
                ? moment(policyData.travel_end_date).format('YYYY-MM-DD')
                : '';
        const newDays = typeof data?.noOfdays !== 'undefined' && data?.noOfdays !== null
            ? String(data.noOfdays)
            : policyData?.number_of_travel_days != null
                ? String(policyData.number_of_travel_days)
                : '';

        if (newStart !== '' && newStart !== oldStart) {
            documentData["travel_start_date"] = newStart;
            changesValues.push({
                title: getTitle("travel_start_date"),
                old: oldStart || null,
                new: newStart
            });
        }

        if (newEnd !== '' && newEnd !== oldEnd) {
            documentData["travel_end_date"] = newEnd;
            changesValues.push({
                title: getTitle("travel_end_date"),
                old: oldEnd || null,
                new: newEnd
            });
        }

        if (newDays !== '' && newDays !== oldDays) {
            documentData["number_of_travel_days"] = parseInt(newDays, 10);
            changesValues.push({
                title: getTitle("number_of_travel_days"),
                old: oldDays !== '' ? parseInt(oldDays, 10) : null,
                new: parseInt(newDays, 10)
            });
        }

        documentData['changesValues'] = changesValues;

        const document_policy_id = documentData?.document_id;
        console.log("documentData===", documentData);
        if (changesValues.length > 0) {
            await forceDocumentEdit(document_policy_id, documentData)
                .then((res) => {
                    console.log("edit doc res===", res);
                    if (res.status === 200) {
                        toast.success("Document endorsed successfully");
                        toggle();
                        refresh();
                    } else {
                        toast.error(res?.data || "Error while updating document");
                    }
                    setIsSubmitting(false);
                })
                .catch((err) => {
                    console.log("error occur while endorsement---", err);

                    const errorCode = err?.response?.data?.code;
                    const errorMessage = err?.response?.data?.error || "Could not update the document. Please try again later.";

                    if (errorCode === 400) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Warning',
                            text: errorMessage
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: errorMessage
                        });
                    }
                    setIsSubmitting(false);
                });
        } else {
            Swal.fire({
                icon: 'info',
                title: 'Info',
                text: "No Changes in Data"
            });

            setIsSubmitting(false);
            refresh();
        }
    }

    // Helper to calculate travel days (keeps behavior consistent with view-quotation)
    const calculateTravelDays = (start, end) => {
        if (!start || !end) return "";
        const startDateObj = new Date(start);
        const endDateObj = new Date(end);
        if (isNaN(startDateObj) || isNaN(endDateObj)) return "";
        const diff = Math.ceil((endDateObj - startDateObj) / (1000 * 60 * 60 * 24));
        return diff > 0 ? diff : "";
    };

    // AMT helper: end date = start + 364 (365 days total)
    const calcAmtEndDate = (start) => {
        if (!start) return "";
        const d = new Date(start);
        if (isNaN(d)) return "";
        d.setDate(d.getDate() + 364);
        return d.toISOString().split("T")[0];
    };

    const messageModal = (e) => {
        toggleRequestForChangeModal();
    }

    const handlePincodeChange = async (event) => {
        const pincode = event;
        setValue("proposers[0].proposer_pin_code", pincode);
        await trigger("proposers[0].proposer_pin_code");
        if (pincode.length === 6) {
            fetchPincodeDetails(pincode);
        } else {
            setStateDetails({});
            setCityDetails({});
            setCityOptions([]);
            // clear nested form values when pincode is cleared/invalid
            await setValue('proposers[0].state', '');
            await setValue('proposers[0].city', '');
            await trigger('proposers[0].state');
            await trigger('proposers[0].city');
        }
    };

    const fetchPincodeDetails = async (pincode) => {
        try {
            const clientConifig = await getClientConfig({ company_id: policyData?.Company?.company_id, name: COMPANY_MASTER_PINCODE });
            const clientKey = clientConifig?.data?.result[0]?.key;
            console.log("clientKey------>", clientKey);
            setStateDetails({ value: 0, label: "Loading..." });
            setCityDetails({ value: 0, label: "Loading..." });

            // const res = await stateCityByPincode(pincode);
            const res = await stateCityByActiveMasterPincode({ pincode: pincode, clientKey: clientKey });
            const pincodeData = res.data.result;
            console.log("pincodeData------>", pincodeData);

            if (pincodeData.length > 0 && pincodeData[0].state_id && pincodeData[0].city_id) {
                const stateValue = {
                    value: pincodeData[0].state_id,
                    label: pincodeData[0].state,
                }

                setStateDetails(stateValue);
                console.log(stateDetails, 'stateDetails');

                // set nested form fields (use label/string values for backend compatibility)
                await setValue('proposers[0].state', pincodeData[0].state || stateValue.label);
                await trigger('proposers[0].state');

                // Build city options with a default placeholder
                const cityOptionsData = [
                    { value: "", label: "Select City", isDisabled: true },
                    ...pincodeData.map((item) => ({
                        value: item.city_id,
                        label: item.city,
                        isDisabled: false
                    })),
                ];

                console.log("cityOptionsData", cityOptionsData);
                setCityOptions(cityOptionsData);

                // Try to pre-select the existing city from policyData if available.
                const existingCity = policyData?.proposers?.[0]?.city;
                const existingCityId = policyData?.proposers?.[0]?.city_id;

                let selectedCity = null;
                if (existingCity && typeof existingCity === 'object' && ('value' in existingCity || 'label' in existingCity)) {
                    selectedCity = existingCity;
                } else if (existingCityId) {
                    selectedCity = cityOptionsData.find(c => String(c.value) === String(existingCityId));
                } else if (existingCity) {
                    selectedCity = cityOptionsData.find(c => String(c.label).toLowerCase() === String(existingCity).toLowerCase());
                }

                // Fallback to the placeholder if no matching city found
                const cityToSet = selectedCity || cityOptionsData[0];

                setCityDetails(cityToSet);
                await setValue("proposers[0].city", cityToSet.label);
                await trigger("proposers[0].city");
                // const cityValue = {
                //     value: pincodeData.city_id,
                //     label: pincodeData.city,
                // };
                // setCityDetails(cityValue);

                // await setValue('proposers[0].city', pincodeData.city || cityValue.label);
                // await trigger('proposers[0].city');
            } else {
                setCityOptions([{ value: 0, label: "No city found", isDisabled: true }]);
                setStateDetails({ value: 0, label: "No state found" });
                setCityDetails({ value: 0, label: "No city found" });
            }
        } catch (err) {
            setStateDetails({ value: 0, label: "Invalid data" });
            setCityDetails({ value: 0, label: "Invalid data" });
            // also clear nested values on error
            await setValue('proposers[0].state', '');
            await setValue('proposers[0].city', '');
            await trigger('proposers[0].state');
            await trigger('proposers[0].city');

        }
    };

    const [startDate, setStartDate] = useState(
        policyData?.travel_start_date
            ? moment(policyData.travel_start_date).format('YYYY-MM-DD')
            : ''
    );

    const [endDate, setEndDate] = useState(
        policyData?.travel_end_date
            ? moment(policyData.travel_end_date).format('YYYY-MM-DD')
            : ''
    );

    useEffect(() => {
    }, [startDate, endDate])

    useEffect(() => {
        console.log("cityOptions in useEffect", cityOptions)
    }, [cityOptions])

    const [noOfdays, setNoOfDays] = useState(policyData?.number_of_travel_days || '');

    useEffect(() => {
        if (startDate && endDate) {
            const start = moment(startDate);
            const end = moment(endDate);
            const diff = end.diff(start, 'days') + 1;
            if (diff > 0) {
                setNoOfDays(diff.toString());
                setValue('noOfdays', diff.toString());
                trigger('noOfdays');
            }
        }
    }, [startDate, endDate]);

    const handleStartDateChange = (e) => {
        const newStart = e.target.value;
        setStartDate(newStart);
        setValue("startDate", newStart);
        trigger("startDate");
        if (isAMT) {
            const autoEnd = calcAmtEndDate(newStart);
            setEndDate(autoEnd);
            setValue("endDate", autoEnd);
            trigger("endDate");
            const tnod = autoEnd ? 365 : "";
            setNoOfDays(tnod.toString());
            setValue('noOfdays', tnod.toString());
            trigger('noOfdays');
        } else {
            const tnod = calculateTravelDays(newStart, endDate);
            setNoOfDays(tnod);
            setValue('noOfdays', tnod);
            trigger('noOfdays');
        }
    };

    const handleEndDateChange = (e) => {
        if (isAMT) return; // ignore manual edits for AMT
        const newEnd = e.target.value;
        setEndDate(newEnd);
        setValue("endDate", newEnd);
        trigger("endDate");
        const tnod = calculateTravelDays(startDate, newEnd);
        setNoOfDays(tnod);
        setValue('noOfdays', tnod);
        trigger('noOfdays');
    };

    const handleNoOfDaysChange = (e) => {
        if (isAMT) return; // fixed 365 for AMT
        const value = e.target.value;
        if (value === "" || /^[0-9\b]+$/.test(value)) {
            setNoOfDays(value);
            setValue("noOfdays", value);
            trigger("noOfdays");
            // If user clears the field, also clear end date (but keep start date)
            if (value === "") {
                setEndDate("");
                setValue("endDate", "");
            } else if (startDate && value) {
                // compute end date from start + value days
                const start = new Date(startDate);
                start.setDate(start.getDate() + Number(value) - 1);
                const newEnd = start.toISOString().split('T')[0];
                setEndDate(newEnd);
                setValue('endDate', newEnd);
                trigger('endDate');
            }
        }
    };

    return (
        <Fragment>
            <Row>
                <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
                    <ModalHeader toggle={toggle} className=" pb-0 mb-2">{"Edit Document"} </ModalHeader>
                    <ModalBody>
                        <Row >
                            <Col sm="12">
                                {loading ? <GetLoader /> : (
                                    <>
                                        <Form className="needs-validation" onSubmit={handleSubmit(submitDetails)}>
                                            <Row>
                                                <Col xl="2" md="2" sm="2" xs="2" className="d-flex align-items-center" >
                                                    {"Scheme Details"}
                                                </Col>
                                                <Col xl="10" md="10" sm="10" xs="10" className="p-2">
                                                    <Card style={{ background: '#f2f2f2', borderRadius: "6px" }} className="border-0 my-0  pb-0">
                                                        <CardBody style={{ fontSize: '14px' }} className="border-0 mx-1 pt-3 px-1 pb-2">
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Company"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="name"
                                                                        type="text"
                                                                        key={policyData?.company_id}
                                                                        defaultValue={policyData?.Company?.client_company_name || ""}
                                                                        {...register('company')}
                                                                        readOnly

                                                                    />

                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Type of Document"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="phone_no"
                                                                        type="text"
                                                                        key={policyData?.type?.title || ""}
                                                                        defaultValue={policyData?.type?.title || ""}
                                                                        {...register('tyoeofdocument')}
                                                                        readOnly

                                                                    />

                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Geographical Cover"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="email"
                                                                        type="text"
                                                                        key={policyData?.geographical_cover?.name}
                                                                        defaultValue={policyData?.geographical_cover?.name}
                                                                        {...register('geographicalcount')}
                                                                        placeholder="Geographical Cover"
                                                                        readOnly
                                                                    />
                                                                </Col>
                                                            </Row>

                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="2" md="2" sm="2" xs="2" className="d-flex align-items-center" >
                                                    {"Journey Details"}
                                                </Col>
                                                <Col xl="10" md="10" sm="10" xs="10" className="p-2">
                                                    <Card style={{ background: '#f2f2f2', borderRadius: "6px" }} className="border-0 my-0  pb-0">
                                                        <CardBody style={{ fontSize: '14px' }} className="border-0 mx-1 pt-3 px-1 pb-2">
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Country"}</span> {!isAMT && <RequiredIndicator />}
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">

                                                                    <Select
                                                                        options={countryList}
                                                                        isMulti
                                                                        // isDisabled={true}
                                                                        placeholder={"Select Country"}
                                                                        //  {...register("country")}
                                                                        // value={policyData?.country_map_docs?.length > 0
                                                                        //     ? policyData.country_map_docs.map(item => ({
                                                                        //         value: item.Country?.country_id, // Assuming country_id is the value
                                                                        //         label: item.Country?.name // Assuming country_name is the display name
                                                                        //     }))
                                                                        value={Array.isArray(country) && country.every(opt => opt?.value && opt?.label) ? country : []}
                                                                        key={stateDetails}
                                                                        name="state"
                                                                        styles={{
                                                                            multiValue: (base) => ({
                                                                                ...base,
                                                                                backgroundColor: "#4433ffcf",
                                                                                color: "#ffff",
                                                                            }),
                                                                            multiValueLabel: (base) => ({
                                                                                ...base,
                                                                                color: "#ffff",
                                                                            }),
                                                                            multiValueRemove: (base) => ({
                                                                                ...base,
                                                                                color: "#ffff",
                                                                                ":hover": {
                                                                                    color: "#ffff",
                                                                                },
                                                                            }),
                                                                        }}
                                                                        onChange={(e) => {
                                                                            setCountry(e || [])
                                                                        }}
                                                                    />
                                                                    {countryError && !isAMT && (
                                                                        <p className="text-danger">Country is required</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Start Date / End Date"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Row>
                                                                        <Col xl="6" md="6" sm="6" xs="6" >
                                                                            <Input
                                                                                className="form-control"
                                                                                name="start_date"
                                                                                placeholder="1-Jan-2025"
                                                                                type="date"
                                                                                defaultValue={policyData?.travel_start_date && moment(policyData?.travel_start_date).format('YYYY-MM-DD')}
                                                                                {...register('startDate')}
                                                                                onChange={(e) => handleStartDateChange(e)}
                                                                                // readOnly
                                                                                min={
                                                                                    moment(new Date()).add(1, 'day').format('YYYY-MM-DD')
                                                                                }
                                                                            />
                                                                        </Col>
                                                                        <Col xl="6" md="6" sm="6" xs="6">
                                                                            <Input
                                                                                className="form-control"
                                                                                name="end_date"
                                                                                placeholder="31-Dec-2025"
                                                                                type="date"
                                                                                {...register('endDate')}
                                                                                defaultValue={policyData?.travel_end_date && moment(policyData?.travel_end_date).format("YYYY-MM-DD")}
                                                                                onChange={(e) => handleEndDateChange(e)}
                                                                                min={startDate}
                                                                            // onChange={(e) => setEndDate(e.target.value)}
                                                                            // key={endDate}
                                                                            // readOnly
                                                                            />
                                                                            {/* <span style={{ color: "red" }}>
                                                                                {errors.end_date && errors.end_date.type === "required" && <span>End Date is required</span>}
                                                                            </span> */}
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"No of Days"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="code"
                                                                        placeholder=""
                                                                        // value={policyData?.dealer?.dealer_code}
                                                                        key={policyData?.number_of_travel_days}
                                                                        defaultValue={noOfdays}
                                                                        // innerRef={register({ required: true })}
                                                                        {...register('noOfdays')}
                                                                        type="text"
                                                                        onChange={(e) => handleNoOfDaysChange(e)}
                                                                        readOnly
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="2" md="2" sm="2" xs="2" className="d-flex align-items-center" >
                                                    {"Proposer Details"}
                                                </Col>
                                                <Col xl="10" md="10" sm="10" xs="10" className="p-2">
                                                    <Card style={{ background: '#f2f2f2', borderRadius: "6px" }} className="border-0 my-0  pb-0">
                                                        <CardBody style={{ fontSize: '14px' }} className="border-0 mx-1 pt-3 px-1 pb-2">
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{policyData?.geographical_cover?.name === 'Domestic' ? 'Passport No' : 'Unique No'}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name={policyData?.geographical_cover?.name === 'Domestic' ? 'Unique No' : 'Passport No'}
                                                                        type="text"
                                                                        key={""}
                                                                        readOnly
                                                                        defaultValue={policyData?.geographical_cover?.name != 'Domestic' ? policyData?.proposers?.map(i => i.proposer_passport_number)?.join(',') : policyData?.proposers?.map(i => i.proposer_unique_number)?.join(',')}
                                                                        {...register('proposers[0].proposer_passport_number')}
                                                                    // onChange={(e) => {
                                                                    //     setValue('proposers[0].proposer_passport_number', e.target.value)
                                                                    //     trigger('proposers[0].proposer_passport_number')
                                                                    // }}
                                                                    />
                                                                    {errors.proposers?.[0]?.proposer_passport_number && (
                                                                        <p className="text-danger">{errors.proposers[0].proposer_passport_number.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Date of Birth"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="date_of_birth"
                                                                        placeholder="31-Dec-2022"
                                                                        type="date"
                                                                        defaultValue={policyData?.proposers?.length > 0 ? moment(policyData?.proposers[0]?.proposer_dob).format('YYYY-MM-DD') : ""}
                                                                        {...register('proposers[0].proposer_dob')}
                                                                        onChange={(e) => {
                                                                            setValue('proposers[0].proposer_dob', e.target.value)
                                                                            trigger('proposers[0].proposer_dob')
                                                                        }}
                                                                    // readOnly
                                                                    />
                                                                    {/* <span style={{ color: "red" }}>
                                                                        {errors.brand && errors.brand.type === "required" && <span>Brand is required</span>}
                                                                    </span> */}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Gender"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">

                                                                    <Input
                                                                        type="select"
                                                                        name="model_id"
                                                                        id="exampleSelect"

                                                                        key={policyData?.proposers?.length > 0 && policyData?.proposers[0].gender}
                                                                        defaultValue={policyData?.proposers?.length > 0 && policyData?.proposers[0].gender}
                                                                        {...register('proposers[0].gender')}
                                                                        onChange={(e) => {
                                                                            setValue('proposers[0].gender', e.target.value)
                                                                            trigger('proposers[0].gender')

                                                                        }}
                                                                    >
                                                                        <option value="" defaultValue={""} >Select Gender</option>
                                                                        <option value="MALE">Male</option>
                                                                        <option value="FEMALE">Female</option>
                                                                        <option value="OTHERS">Others</option>
                                                                    </Input>
                                                                    {errors.proposers?.[0]?.gender && (
                                                                        <p className="text-danger">{errors.proposers[0].gender.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Title"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        type="select"
                                                                        name="transmission_id"
                                                                        id="exampleSelect"
                                                                        value={proposerTitle}
                                                                        // defaultValue={policyData?.proposers?.length > 0 ? policyData?.proposers[0].proposer_title  : ""}
                                                                        // key={policyData?.proposers[0]?.proposer_title}
                                                                        // innerRef={register()}
                                                                        {...register('proposers[0].proposer_title')}
                                                                        onChange={(e) => {
                                                                            setValue('proposers[0].proposer_title', e.target.value)
                                                                            trigger('proposers[0].proposer_title')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, traveller_passport: e.target.value } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    >
                                                                        <option value="" defaultValue={""}>Select Title</option>
                                                                        <option value="Mr">{'Mr'}</option>
                                                                        <option value="Mrs">{'Mrs'}</option>
                                                                        <option value="Ms">{'Ms'}</option>
                                                                        <option value="Miss">{'Miss'}</option>
                                                                        <option value="Dr">{'Dr'}</option>
                                                                        <option value="Prof">{'Prof'}</option>
                                                                        <option value="Master">{'Master'}</option>
                                                                    </Input>
                                                                    {errors.proposers?.[0]?.proposer_title && (
                                                                        <p className="text-danger">{errors.proposers[0].proposer_title.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"First Name"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="First Name"
                                                                        // maxLength={10}

                                                                        type="text"
                                                                        placeholder="First Name"
                                                                        key={policyData?.proposers?.length > 0 && policyData?.proposers[0]?.proposer_first_name}

                                                                        defaultValue={policyData?.proposers?.length > 0 && policyData?.proposers[0]?.proposer_first_name}
                                                                        {...register('proposers[0].proposer_first_name')}
                                                                        onChange={(e) => {
                                                                            setValue('proposers[0].proposer_first_name', e.target.value)
                                                                            trigger('proposers[0].proposer_first_name')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, traveller_passport: e.target.value } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {errors.proposers?.[0]?.proposer_first_name && (
                                                                        <p className="text-danger">{errors.proposers[0].proposer_first_name.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Middle Name"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="Middle Name"
                                                                        placeholder='Middle Name'
                                                                        type="text"
                                                                        key={policyData?.proposers?.length > 0 ? policyData?.proposers[0]?.proposer_middle_name : ""}
                                                                        defaultValue={policyData?.proposers?.length > 0 ? policyData?.proposers[0]?.proposer_middle_name : ""}
                                                                        {...register('proposers[0].proposer_middle_name')}
                                                                        onChange={(e) => {
                                                                            setValue('proposers[0].proposer_middle_name', e.target.value)
                                                                            trigger('proposers[0].proposer_middle_name')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, traveller_passport: e.target.value } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {errors.proposers?.[0]?.proposer_middle_name && (
                                                                        <p className="text-danger">{errors.proposers[0].proposer_middle_name.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Last Name"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="Last Name"
                                                                        placeholder='Last Name'
                                                                        type="text"
                                                                        key={policyData?.proposers?.length > 0 ? policyData?.proposers[0]?.proposer_last_name : ""}
                                                                        defaultValue={policyData?.proposers?.length > 0 && policyData?.proposers[0]?.proposer_last_name}
                                                                        {...register('proposers[0].proposer_last_name')}
                                                                        onChange={(e) => {
                                                                            setValue('proposers[0].proposer_last_name', e.target.value)
                                                                            trigger('proposers[0].proposer_last_name')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, traveller_passport: e.target.value } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {errors.proposers?.[0]?.proposer_last_name && (
                                                                        <p className="text-danger">{errors.proposers[0].proposer_last_name.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="2" md="2" sm="2" xs="2" className="d-flex align-items-center" >
                                                    {"Traveller Details"}
                                                </Col>
                                                <Col xl="10" md="10" sm="10" xs="10" className="p-2">
                                                    <Card style={{ background: '#f2f2f2', borderRadius: "6px" }} className="border-0 my-0  pb-0">
                                                        <CardBody style={{ fontSize: '14px' }} className="border-0 mx-1 pt-3 px-1 pb-2">

                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{policyData?.geographical_cover?.name === 'Domestic' ? "Unique Number" : "Passport No "}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="Passport No"
                                                                        placeholder='Passport No'
                                                                        type="text"
                                                                        key={""}
                                                                        readOnly
                                                                        defaultValue={policyData?.travellers?.length > 0 && policyData?.geographical_cover?.name == 'Domestic' ? policyData?.travellers[0]?.traveller_unique_number : policyData?.travellers?.length > 0 ? policyData?.travellers[0]?.traveller_passport : ""}
                                                                        {...register('travellers[0].traveller_passport')}
                                                                        onChange={(e) => {
                                                                            setValue('travellers[0].traveller_passport', e.target.value)
                                                                            trigger('travellers[0].traveller_passport')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, traveller_passport: e.target.value } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {errors.travellers?.[0]?.traveller_passport && (
                                                                        <p className="text-danger">{errors.travellers[0].traveller_passport.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Date of Birth"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="date_of_birth"
                                                                        placeholder="31-Dec-2022"
                                                                        type="date"
                                                                        defaultValue={policyData?.travellers?.length > 0 && policyData?.travellers[0]?.traveller_dob ? moment(policyData?.travellers[0]?.traveller_dob).format('YYYY-MM-DD') : ""}
                                                                        {...register('travellers[0].traveller_dob')}
                                                                        onChange={(e) => {
                                                                            setValue('travellers[0].traveller_dob', e.target.value)
                                                                            trigger('travellers[0].traveller_dob')
                                                                        }}
                                                                    // readOnly
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Gender"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">

                                                                    <Input
                                                                        type="select"
                                                                        name="model_id"
                                                                        id="exampleSelect"
                                                                        defaultValue={policyData?.travellers?.length > 0 && policyData?.travellers[0]?.gender}
                                                                        key={policyData?.travellers?.length > 0 && policyData?.travellers[0]?.gender}
                                                                        {...register('travellers[0].gender')}
                                                                        onChange={(e) => {
                                                                            setValue('travellers[0].gender', e.target.value)
                                                                            trigger('travellers[0].gender')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, gender: e } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    >
                                                                        <option value="" defaultValue={""} >Select Gender</option>
                                                                        <option value="MALE">Male</option>
                                                                        <option value="FEMALE">Female</option>
                                                                        <option value="OTHERS">Others</option>

                                                                    </Input>
                                                                    {errors.travellers?.[0]?.gender && (
                                                                        <p className="text-danger">{errors.travellers[0].gender.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Title"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        type="select"
                                                                        name="transmission_id"
                                                                        id="exampleSelect"
                                                                        defaultValue={policyData?.travellers?.length > 0 && policyData?.travellers[0]?.title}
                                                                        key={policyData?.travellers?.length > 0 && policyData?.travellers[0]?.title
                                                                        }
                                                                        {...register('travellers[0].title')}
                                                                        onChange={(e) => {
                                                                            setValue('travellers[0].title', e.target.value)
                                                                            trigger('travellers[0].title')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, title: e } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    >
                                                                        <option value="">{'Select'}</option>
                                                                        <option value="Mr">{'Mr'}</option>
                                                                        <option value="Mrs">{'Mrs'}</option>
                                                                        <option value="Miss">{'Miss'}</option>
                                                                        <option value="Dr">{'Dr'}</option>
                                                                        <option value="Prof">{'Prof'}</option>
                                                                        <option value="Master">{'Master'}</option>
                                                                    </Input>
                                                                    {errors.travellers?.[0]?.title && (
                                                                        <p className="text-danger">{errors.travellers[0].title.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"First Name"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="First Name"
                                                                        // maxLength={10}
                                                                        placeholder='First Name'
                                                                        type="text"

                                                                        key={policyData?.vehicle?.registration_no}
                                                                        defaultValue={policyData?.travellers?.length > 0 ? policyData?.travellers[0]?.firstName : ""}
                                                                        {...register('travellers[0].firstName')}
                                                                        onChange={(e) => {
                                                                            setValue('travellers[0].firstName', e.target.value)
                                                                            trigger('travellers[0].firstName')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, firstName: e.target.value } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {errors.travellers?.[0]?.firstName && (
                                                                        <p className="text-danger">{errors.travellers[0].firstName.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Middle Name"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="Middle Name"
                                                                        placeholder='Middle Name'
                                                                        type="text"
                                                                        key={policyData?.travellers?.length > 0 ? policyData?.travellers[0]?.middleName : ""}
                                                                        defaultValue={policyData?.travellers?.length > 0 && policyData?.travellers[0]?.middleName ? policyData?.travellers[0]?.middleName : ""}
                                                                        {...register('travellers[0].middleName')}
                                                                        onChange={(e) => {
                                                                            setValue('travellers[0].middleName', e.target.value)
                                                                            trigger('travellers[0].middleName')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, middleName: e.target.value } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {errors.travellers?.[0]?.middleName && (
                                                                        <p className="text-danger">{errors.travellers[0].middleName.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Last Name"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="Last Name"
                                                                        placeholder='Last Name'
                                                                        type="text"
                                                                        key={policyData?.travellers?.length > 0 ? policyData?.travellers[0]?.lastName : ""}

                                                                        defaultValue={policyData?.travellers?.length > 0 && policyData?.travellers[0]?.lastName}
                                                                        {...register('travellers[0].lastName')}
                                                                        onChange={(e) => {
                                                                            setValue('travellers[0].lastName', e.target.value)
                                                                            trigger('travellers[0].lastName')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, lastName: e.target.value } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {errors.travellers?.[0]?.lastName && (
                                                                        <p className="text-danger">{errors.travellers[0].lastName.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Critical Illness"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        type="select"
                                                                        name="transmission_id"
                                                                        id="exampleSelect"
                                                                        value={travellerCriticalIllnessValue}
                                                                        //    key={policyData?.travellers[0]?.transmission_id}
                                                                        {...register('travellers[0].critical_illness')}
                                                                        disabled
                                                                        readOnly
                                                                    >
                                                                        <option value="">Select Illness</option>
                                                                        <option value="None">No Critical Illness</option>
                                                                        <option value="Cancer_and_Leukemia">Cancer / Leukemia</option>
                                                                        <option value="Malignant_tumor">Malignant Tumor</option>
                                                                        <option value="Cardiac_ailments">Cardiac ailments</option>
                                                                        <option value="COPD">COPD</option>
                                                                        <option value="HIV/AIDS">HIV /AIDS</option>
                                                                        <option value="Insulin_dependent_iabetes">Insulin Dependent Diabetes</option>
                                                                        <option value="Kidney_ailment">Kidney Ailment</option>
                                                                        <option value="Liver_disease">Liver Disease</option>
                                                                        <option value="Neurological_disorder">Neurological Disorder</option>
                                                                        <option value="Stroke /Paralysis">Stroke /Paralysis</option>
                                                                        <option value="Thalasemia">Thalasemia</option>
                                                                    </Input>
                                                                    {/* <span style={{ color: "red" }}>
                                                                        {errors.vehicle && errors.vehicle.type === "required" && <span>Sale Date is required</span>}
                                                                    </span> */}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Pre Existing Disease"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        type="select"
                                                                        name="transmission_id"
                                                                        id="exampleSelect"
                                                                        defaultValue={
                                                                        policyData?.travellers?.[0]?.ped_type
                                                                            ? "Yes"
                                                                            : "No"  }
                                                                        key={policyData?.transmission?.transmission_id}
                                                                        {...register('travellers[0].ped')}
                                                                        readOnly
                                                                        disabled
                                                                    >
                                                                        <option value="">Select PED Type</option>
                                                                        <option value="Yes">Yes</option>
                                                                        <option value="No">No</option>

                                                                    </Input>
                                                                    {/* <span style={{ color: "red" }}>
                                                                        {errors.vehicle && errors.vehicle.type === "required" && <span>Sale Date is required</span>}
                                                                    </span> */}
                                                                </Col>
                                                            </Row>
                                                            {policyData?.travellers?.length > 0 && policyData?.travellers[0]?.pre_existing_disease == 'Yes' && (
                                                                <Row>
                                                                    <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                        <span>{"PED Type / Suffering Since / Under Medictation"}</span>
                                                                    </Col>
                                                                    <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                        <Row>
                                                                            <Col xl="3" md="3" sm="3" xs="3" className="pr-0">
                                                                                <Input
                                                                                    className="form-control"
                                                                                    name="PED_Type"
                                                                                    // value={policyData?.user?.pin_code}
                                                                                    type="text"
                                                                                    key={policyData?.user?.pin_code}
                                                                                    defaultValue={policyData?.travellers?.length > 0 && policyData?.travellers[0]?.ped_type}
                                                                                    {...register('travellers[0].pedtype')}
                                                                                    readOnly
                                                                                />
                                                                                {/* <span style={{ color: "red" }}>
                                                                                    {errors.pin_code && errors.pin_code.type === "required" && <span>Pincode is required</span>}
                                                                                </span> */}
                                                                            </Col>
                                                                            <Col xl="5" md="5" sm="5" xs="5">
                                                                                <Input
                                                                                    className="form-control"
                                                                                    name="Suffering Since"
                                                                                    placeholder="Suffering Since"

                                                                                    type="date"

                                                                                    defaultValue={policyData?.travellers?.length > 0 && policyData?.travellers[0]?.suffering_since}
                                                                                    readOnly
                                                                                    {...register('travellers[0].sufferingsince')}

                                                                                />
                                                                                {/* <span style={{ color: "red" }}>
                                                                                    {errors.city && errors.city.type === "required" && <span>City is required</span>}
                                                                                </span> */}
                                                                            </Col>
                                                                            <Col xl="4" md="4" sm="4" xs="4" className="pl-0">
                                                                                <Input
                                                                                    type="select"
                                                                                    name="under medictation"
                                                                                    id="exampleSelect"
                                                                                    defaultValue={policyData?.travellers?.length > 0 && policyData?.travellers[0]?.under_medication}
                                                                                    {...register('travellers[0].under_medictation')}
                                                                                    readOnly
                                                                                >
                                                                                    <option value="">Select PED Type</option>
                                                                                    <option value="Yes">Yes</option>
                                                                                    <option value="No">No</option>

                                                                                </Input>
                                                                                {/* <span style={{ color: "red" }}>
                                                                                    {errors.state && errors.state.type === "required" && <span>State is required</span>}
                                                                                </span> */}
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="2" md="2" sm="2" xs="2" className="d-flex align-items-center" >
                                                    {"Nominee Details"}
                                                </Col>
                                                <Col xl="10" md="10" sm="10" xs="10" className="p-2">
                                                    <Card style={{ background: '#f2f2f2', borderRadius: "6px" }} className="border-0 my-0  pb-0">
                                                        <CardBody style={{ fontSize: '14px' }} className="border-0 mx-1 pt-3 px-1 pb-2">
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Relationship with proposer"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        type="select"
                                                                        name="under medictation"
                                                                        id="exampleSelect"
                                                                        value={nomineeRelationValue}
                                                                        {...register('nominees[0].nominee_relation')}
                                                                        onChange={(e) => {
                                                                            setValue('nominees[0].nominee_relation', e.target.value)
                                                                            trigger('nominees[0].nominee_relation')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, gender: e } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    >
                                                                        <option value="">{'Select'}</option>
                                                                        <option value="spouse ">{'spouse '}</option>
                                                                        <option value="Son">{'Son'}</option>
                                                                        <option value="Daughter">{'Daughter'}</option>
                                                                        <option value="Mother">{'Mother'}</option>
                                                                        <option value="Father">{'Father'}</option>
                                                                        <option value="Brother">{'Brother'}</option>
                                                                        <option value="Sister">{'Sister'}</option>
                                                                        <option value="Grand_Father">{'Grand Father'}</option>
                                                                        <option value="Grand_Mother">{'Grand Mother'}</option>
                                                                        <option value="Grandson">{'Grand Son'}</option>
                                                                        <option value="Grand_Daughter">{'Grand Daughter'}</option>
                                                                        <option value="Guardian">{'Guardian'}</option>
                                                                        <option value="Legal_Heir">{'Legal Heir'}</option>

                                                                    </Input>
                                                                    {errors.nominees?.[0]?.nominee_relation && (
                                                                        <p className="text-danger">{errors.nominees[0].nominee_relation.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Date of birth"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">

                                                                    <Input
                                                                        className="form-control"
                                                                        name="Suffering Since"
                                                                        placeholder="Suffering Since"
                                                                        // type="text"
                                                                        type="date"
                                                                        // defaultValue={policyData?.nominees?.length > 0 && policyData?.nominees[0]?.nominee_dob && moment(policyData?.nominees[0]?.nominee_dob)}
                                                                        {...register('nominees[0].nominee_dob')}
                                                                        onChange={(e) => {
                                                                            setValue('nominees[0].nominee_dob', e.target.value);
                                                                        }}
                                                                        defaultValue={policyData?.nominees?.length > 0 && policyData?.nominees[0]?.nominee_dob ? moment(policyData?.nominees[0]?.nominee_dob).format('YYYY-MM-DD') : ""}
                                                                        readyOnly
                                                                    />
                                                                    {/* <span style={{ color: "red" }}>
                                                                        {errors.amount && errors.amount.type === "required" && <span>Amount is required</span>}
                                                                    </span> */}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Gender"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        type="select"
                                                                        name="nominee_gender"
                                                                        id="exampleSelect"
                                                                        value={nomineeGender}
                                                                        // key={policyData?.length > 0 && policyData?.nominees?.[0]?.nominee_gender}
                                                                        // defaultValue={policyData?.length > 0 && policyData?.nominees?.[0]?.nominee_gender}
                                                                        {...register('nominees[0].nominee_gender')}
                                                                        onChange={(e) => {
                                                                            setValue('nominees[0].nominee_gender', e.target.value)
                                                                            trigger('nominees[0].nominee_gender')
                                                                        }}
                                                                    >
                                                                        <option value="">Select Gender</option>
                                                                        <option value="MALE">Male</option>
                                                                        <option value="FEMALE">Female</option>
                                                                        <option value="OTHERS">Others</option>
                                                                    </Input>
                                                                    {errors.nominees?.[0]?.nominee_gender && (
                                                                        <p className="text-danger">{errors.nominees[0].nominee_gender.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Title"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        type="select"
                                                                        name="nominee_title"
                                                                        id="nomineeTitleSelect"
                                                                        value={nomineeTitle}
                                                                        {...register('nominees[0].nominee_title')}
                                                                        onChange={(e) => {
                                                                            setValue('nominees[0].nominee_title', e.target.value)
                                                                        }}
                                                                    >
                                                                        <option value="">{'Select'}</option>
                                                                        <option value="Mr">{'Mr'}</option>
                                                                        <option value="Mrs">{'Mrs'}</option>
                                                                        <option value="Ms">{'Ms'}</option>
                                                                        <option value="Miss">{'Miss'}</option>
                                                                        <option value="Dr">{'Dr'}</option>
                                                                        <option value="Prof">{'Prof'}</option>
                                                                        <option value="Master">{'Master'}</option>
                                                                    </Input>
                                                                    {/* <span style={{ color: "red" }}>
                                                                        {errors.transmission_id && errors.transmission_id.type === "required" && <span>Transmission is required</span>}
                                                                    </span> */}

                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"First Name"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="First Name"
                                                                        // maxLength={10}

                                                                        type="text"
                                                                        placeholder="First Name"

                                                                        defaultValue={policyData?.nominees?.length > 0 ? policyData?.nominees[0]?.nominee_firstName : ""}

                                                                        {...register('nominees[0].nominee_firstName')}
                                                                        onChange={(e) => {
                                                                            setValue('nominees[0].nominee_firstName', e.target.value)
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, gender: e } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {/* <span style={{ color: "red" }}>
                                                                        {errors.registration_no && <span>{errors.registration_no.message}</span>}
                                                                    </span> */}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Middle Name"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="Middle Name"
                                                                        placeholder='Middle Name'
                                                                        type="text"

                                                                        defaultValue={policyData?.nominees?.length > 0 ? policyData?.nominees[0]?.nominee_middleName : ""}
                                                                        {...register('nominees[0].nominee_middleName')}
                                                                        onChange={(e) => {
                                                                            setValue('nominees[0].nominee_middleName', e.target.value)
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, gender: e } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {/* <span style={{ color: "red" }}>
                                                                        {errors.vehicle && errors.vehicle.type === "required" && <span>Sale Date is required</span>}
                                                                    </span> */}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Last Name"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="Last Name"
                                                                        placeholder='Last Name'
                                                                        type="text"
                                                                        //   key={policyData?.nominees[0]?.sale_date}
                                                                        defaultValue={policyData?.nominees?.length > 0 ? policyData?.nominees[0]?.nominee_lastName : ""}
                                                                        {...register('nominees[0].nominee_lastName')}
                                                                        onChange={(e) => {
                                                                            setValue('nominees[0].nominee_lastName', e.target.value)
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, gender: e } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {/* <span style={{ color: "red" }}>
                                                                        {errors.vehicle && errors.vehicle.type === "required" && <span>Sale Date is required</span>}
                                                                    </span> */}
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="2" md="2" sm="2" xs="2" className="d-flex align-items-center" >
                                                    {"Proposer Address"}
                                                </Col>
                                                <Col xl="10" md="10" sm="10" xs="10" className="p-2">
                                                    <Card style={{ background: '#f2f2f2', borderRadius: "6px" }} className="border-0 my-0  pb-0">
                                                        <CardBody style={{ fontSize: '14px' }} className="border-0 mx-1 pt-3 px-1 pb-2">

                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Pin Code / State / District"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Row>
                                                                        <Col xl="3" md="3" sm="3" xs="3" className="pr-0">
                                                                            <Input
                                                                                className="form-control"
                                                                                name="pin_code"
                                                                                // value={policyData?.user?.pin_code}
                                                                                type="text"
                                                                                // key={policyData?.user?.pin_code}
                                                                                defaultValue={policyData?.proposers?.length > 0 ? policyData?.proposers[0]?.proposer_pin_code : ""}
                                                                                // {...register('proposer[0].pincode')}
                                                                                onKeyPress={(event) => {
                                                                                    if (!/[0-9]/.test(event.key)) {
                                                                                        event.preventDefault();
                                                                                    }
                                                                                    if (event.target.value.length >= 6) {
                                                                                        event.preventDefault();
                                                                                    }
                                                                                }}
                                                                                // {...pinCode}
                                                                                onBlur={(e) => {
                                                                                    handlePincodeChange(e.target.value);
                                                                                }}
                                                                                {...register('proposers[0].proposer_pin_code')}
                                                                                onChange={(e) => {
                                                                                    handlePincodeChange(e.target.value)
                                                                                    //  setValue('proposers[0].proposer_pin_code', e.target.value)
                                                                                    //     // trigger('proposers[0].proposer_pin_code')
                                                                                    //     // setPolicyData(prevState => ({
                                                                                    //     //     ...prevState,
                                                                                    //     //     travellers: prevState.travellers.map((traveller, index) =>
                                                                                    //     //         index === 0 ? { ...traveller, gender: e } : traveller
                                                                                    //     //     )
                                                                                    //     // }));
                                                                                }}
                                                                            />
                                                                            {errors.proposers?.[0]?.proposer_pin_code && (
                                                                                <p className="text-danger">{errors.proposers[0].proposer_pin_code.message}</p>
                                                                            )}
                                                                            <input type="hidden" {...register('proposers[0].state')} />
                                                                            <input type="hidden" {...register('proposers[0].city')} />
                                                                        </Col>
                                                                        <Col xl="5" md="5" sm="5" xs="5">

                                                                            <Select
                                                                                isOptionDisabled={(option) => option.disabled}
                                                                                isSearchable={true}
                                                                                placeholder={"Select State"}
                                                                                //  {...register("state")}
                                                                                value={
                                                                                    Object.keys(stateDetails).length > 0
                                                                                        ? stateDetails
                                                                                        : ""
                                                                                }
                                                                                name="state"
                                                                                styles={{
                                                                                    multiValue: (base) => ({
                                                                                        ...base,
                                                                                        backgroundColor: "#4433ffcf",
                                                                                        color: "#ffff",
                                                                                    }),
                                                                                    multiValueLabel: (base) => ({
                                                                                        ...base,
                                                                                        color: "#ffff",
                                                                                    }),
                                                                                    multiValueRemove: (base) => ({
                                                                                        ...base,
                                                                                        color: "#ffff",
                                                                                        ":hover": {
                                                                                            color: "#ffff",
                                                                                        },
                                                                                    }),
                                                                                }}
                                                                                isDisabled={true}
                                                                            />
                                                                            {/* <span style={{ color: "red" }}>
                                                                                {errors.city && errors.city.type === "required" && <span>City is required</span>}
                                                                            </span> */}
                                                                        </Col>
                                                                        <Col xl="4" md="4" sm="4" xs="4" className="pl-0">
                                                                            <Select
                                                                                // isOptionDisabled={(option) => option.disabled}
                                                                                isSearchable={true}
                                                                                placeholder={"Select City"}
                                                                                {...register("city")}
                                                                                value={
                                                                                    Object.keys(cityDetails).length > 0
                                                                                        ? cityDetails
                                                                                        : ""
                                                                                }
                                                                                options={cityOptions}
                                                                                name="city"
                                                                                styles={{
                                                                                    multiValue: (base) => ({
                                                                                        ...base,
                                                                                        backgroundColor: "#4433ffcf",
                                                                                        color: "#ffff",
                                                                                    }),
                                                                                    multiValueLabel: (base) => ({
                                                                                        ...base,
                                                                                        color: "#ffff",
                                                                                    }),
                                                                                    multiValueRemove: (base) => ({
                                                                                        ...base,
                                                                                        color: "#ffff",
                                                                                        ":hover": {
                                                                                            color: "#ffff",
                                                                                        },
                                                                                    }),
                                                                                }}
                                                                                onChange={async (selected) => {
                                                                                    await setValue("proposers[0].city", selected.label);
                                                                                    await setCityDetails(selected)
                                                                                    await trigger("proposers[0].city");
                                                                                }}
                                                                                isDisabled={
                                                                                    !cityOptions ||
                                                                                    cityOptions.length === 0 ||
                                                                                    (cityOptions.length === 1 && cityOptions[0].label === "No city found")
                                                                                }
                                                                            // isDisabled={true}
                                                                            />

                                                                            {errors?.proposers?.[0]?.city && (
                                                                                <span className="text-danger">
                                                                                    {errors.proposers[0].city.message}
                                                                                </span>
                                                                            )}

                                                                        </Col>
                                                                    </Row>
                                                                </Col>

                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Mobile Number"}</span><RequiredIndicator />

                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="phone_no"
                                                                        // value={policyData?.user?.phone_no}
                                                                        type="text"
                                                                        key={policyData?.user?.phone_no}
                                                                        defaultValue={policyData?.proposers?.length > 0 ? policyData?.proposers[0]?.proposer_mobile : ""}
                                                                        //innerRef={register({ required: true, pattern: /^[6-9]\d+$/, minLength: 10, maxLength: 10 })}
                                                                        //{...register('proposer[0].mobilenumber')}
                                                                        placeholder="e.g +91 9000000009"
                                                                        onKeyPress={(event) => {
                                                                            if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                            }
                                                                            if (event.target.value.length >= 10) {
                                                                                event.preventDefault();
                                                                            }
                                                                        }}
                                                                        {...register('proposers[0].proposer_mobile')}
                                                                        onChange={(e) => {
                                                                            setValue('proposers[0].proposer_mobile', e.target.value)
                                                                            trigger('proposers[0].proposer_mobile')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, gender: e } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {errors.proposers?.[0]?.proposer_mobile && (
                                                                        <p className="text-danger">{errors.proposers[0].proposer_mobile.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Email ID"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="email"
                                                                        // value={policyData?.user?.email}
                                                                        type="text"
                                                                        key={policyData?.user?.email}
                                                                        defaultValue={policyData?.proposers?.length > 0 ? policyData?.proposers[0]?.proposer_email : ""}
                                                                        // innerRef={register({ required: true, pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/ })}
                                                                        // {...register('proposer[0].email')}
                                                                        placeholder="e.g mailto:john.doe@mail.com"
                                                                        {...register('proposers[0].proposer_email')}
                                                                        onChange={(e) => {
                                                                            setValue('proposers[0].proposer_email', e.target.value)
                                                                            trigger('proposers[0].proposer_email')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, gender: e } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {errors.proposers?.[0]?.proposer_email && (
                                                                        <p className="text-danger">{errors.proposers[0].proposer_email.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Address"}</span><RequiredIndicator />
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="Address"
                                                                        // value={policyData?.user?.Address}
                                                                        type="text"
                                                                        //   key={policyData?.user?.Address}
                                                                        defaultValue={policyData?.proposers?.length > 0 ? policyData?.proposers[0]?.proposer_address : ""}
                                                                        //   innerRef={register({ required: true })}
                                                                        {...register('proposers[0].proposer_address')}
                                                                        onChange={(e) => {
                                                                            setValue('proposers[0].proposer_address', e.target.value)
                                                                            trigger('proposers[0].proposer_address')
                                                                            // setPolicyData(prevState => ({
                                                                            //     ...prevState,
                                                                            //     travellers: prevState.travellers.map((traveller, index) =>
                                                                            //         index === 0 ? { ...traveller, gender: e } : traveller
                                                                            //     )
                                                                            // }));
                                                                        }}
                                                                    />
                                                                    {errors.proposers?.[0]?.proposer_address && (
                                                                        <p className="text-danger">{errors.proposers[0].proposer_address.message}</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="2" md="2" sm="2" xs="2" className="d-flex align-items-center" >
                                                    {"Reason for Change / Upload Document"}
                                                </Col>
                                                <Col xl="10" md="10" sm="10" xs="10" className="p-2">
                                                    <Card style={{ background: '#f2f2f2', borderRadius: "6px" }} className="border-0 my-0  pb-0">
                                                        <CardBody style={{ fontSize: '14px' }} className="border-0 mx-1 pt-3 px-1 pb-2">
                                                            <Row className='mr-0'>
                                                                <Col xl="9" md="9" sm="9" xs="9">
                                                                    <Row>
                                                                        <Col xl="6" md="6" sm="6" xs="6" className="d-flex align-items-center">
                                                                            <span>{"Select Reason for Change"}</span>
                                                                        </Col>
                                                                        <Col xl="6" md="6" sm="6" xs="6" className="mb-2 pl-0">
                                                                            <Select
                                                                                options={options}
                                                                                name="created_reason"
                                                                                id="exampleSelect"
                                                                                // key={}
                                                                                defaultValue={''}
                                                                                {...register("created_reason")}
                                                                                onChange={async (selected) => {
                                                                                    setSelectedOption(selected);
                                                                                    await setValue("created_reason", selected ? selected.value : '');
                                                                                    await trigger('created_reason');
                                                                                }}

                                                                            >

                                                                            </Select>
                                                                            <span style={{ color: "red" }}>
                                                                                {errors.created_reason && <span>{errors.created_reason.message}</span>}
                                                                            </span>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col xl="6" md="6" sm="6" xs="6" className="d-flex align-items-center">
                                                                            <span>{"State Reason for Change"}</span>
                                                                        </Col>
                                                                        <Col xl="6" md="6" sm="6" xs="6" className="mb-2 pl-0">
                                                                            <Input
                                                                                type="textarea"
                                                                                name="created_remark"
                                                                                id="exampleText"
                                                                                defaultValue={''}
                                                                                {...register("created_remark")}

                                                                                onChange={(e) => {
                                                                                    setValue('created_remark', e.target.value)
                                                                                    trigger('created_remark')

                                                                                }}
                                                                            />

                                                                            <span style={{ color: "red" }}>
                                                                                {errors.created_remark && <span>{errors?.created_remark?.message}</span>}
                                                                            </span>
                                                                        </Col>

                                                                    </Row>
                                                                </Col>
                                                                <Col xl="3" md="3" sm="3" xs="3" className="">
                                                                    <div>
                                                                        <div className='d-flex justify-content-center'>
                                                                            <FileUploadComponent
                                                                                name="image_url" setValue={setValue} trigger={trigger} register={register} getValues={getValues}
                                                                            />

                                                                        </div>

                                                                    </div>
                                                                </Col>

                                                            </Row>

                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="2" md="2" sm="2" xs="2" className="d-flex align-items-center" >
                                                    {"GST Information"}
                                                </Col>
                                                <Col xl="10" md="10" sm="10" xs="10" className="p-2">
                                                    <Card style={{ background: '#f2f2f2', borderRadius: "6px" }} className="border-0 my-0  pb-0">
                                                        <CardBody style={{ fontSize: '14px' }} className="border-0 mx-1 pt-3 px-1 pb-2">
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Is GSTN"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-6" style={{ marginBottom: "32px" }}>
                                                                    <Input
                                                                        name="isGSTN"
                                                                        type="checkbox"
                                                                        checked={!!policyData?.isGSTN}
                                                                        readOnly
                                                                        disabled
                                                                        style={{ width: "18px", height: "18px", marginTop: "6px", marginLeft: '0.5rem' }}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Customer Email"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="customer_email"
                                                                        type="text"
                                                                        key={policyData?.customer_email || ""}
                                                                        defaultValue={policyData?.customer_email || ""}
                                                                        readOnly
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Customer Mobile"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="customer_mobile"
                                                                        type="text"
                                                                        key={policyData?.customer_mobile || ""}
                                                                        defaultValue={policyData?.customer_mobile || ""}
                                                                        readOnly
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Customer GSTN"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="customer_gstn"
                                                                        type="text"
                                                                        key={policyData?.customer_gstn || ""}
                                                                        defaultValue={policyData?.customer_gstn || ""}
                                                                        readOnly
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Customer Company Name"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="customer_company_name"
                                                                        type="text"
                                                                        key={policyData?.customer_company_name || ""}
                                                                        defaultValue={policyData?.customer_company_name || ""}
                                                                        readOnly
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="4" md="4" sm="4" xs="4" className="d-flex align-items-center">
                                                                    <span>{"Customer Company Address"}</span>
                                                                </Col>
                                                                <Col xl="8" md="8" sm="8" xs="8" className="mb-2">
                                                                    <Input
                                                                        className="form-control"
                                                                        name="customer_company_address"
                                                                        type="text"
                                                                        key={policyData?.customer_company_address || ""}
                                                                        defaultValue={policyData?.customer_company_address || ""}
                                                                        readOnly
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <GetModalFooter handleSubmit={handleSubmit(submitDetails)} isSubmitting={isSubmitting} toggle={toggle} mode="Save" />
                                        </Form>
                                    </>
                                )}
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
            </Row>
            {requestForChnageModal && <RequestForChnageModal isOpen={requestForChnageModal} toggle={toggleRequestForChangeModal} parenttoggle={toggle} refresh={refresh} ticketID={ticketID} />}
        </Fragment>

    );
};

export default EditPolicyProductChangeModal;
